export default __webpack_public_path__ + "static/twitter-7e40f617aaa8eca864bb940f5e0347c1.png";